module.exports = __webpack_public_path__ + "img/productBgImg19.39c6ceb6.png";